<h1 mat-dialog-title>Set Opening Balances</h1>

<div mat-dialog-content class="dialog-content" [formGroup]="form">
  <div class="meta-grid">
    <mat-form-field appearance="fill">
      <mat-label>Posted At</mat-label>
      <input matInput type="date" formControlName="postedAt" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Source</mat-label>
      <input matInput formControlName="source" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>External Reference</mat-label>
      <input matInput formControlName="externalReference" />
    </mat-form-field>
  </div>

  <mat-form-field appearance="fill" class="offset-field">
    <mat-label>Offset Account (used if needed)</mat-label>
    <mat-select formControlName="offsetAccountId">
      <mat-option value="">None</mat-option>
      @for (account of sortedAccounts; track account) {
        <mat-option [value]="account.id">
          {{accountLabel(account)}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <p class="help-text">
    Enter signed opening balance per account. Positive uses the account normal side; negative uses the opposite side.
  </p>

  <div class="rows" formArrayName="rows">
    <div class="row-head">
      <span>Account</span>
      <span>Opening Balance</span>
      <span>Memo</span>
      <span></span>
    </div>

    @for (row of rowGroups; track row; let i = $index) {
      <div class="row-item" [formGroupName]="i">
        <mat-form-field appearance="fill">
          <mat-select formControlName="accountId" placeholder="Select account">
            @for (account of sortedAccounts; track account) {
              <mat-option [value]="account.id">
                {{accountLabel(account)}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <input matInput type="number" step="0.01" formControlName="openingBalance" placeholder="e.g. 1000.00 or -250.00" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <input matInput formControlName="memo" placeholder="Optional memo" />
        </mat-form-field>
        <button mat-icon-button type="button" (click)="removeRow(i)" [disabled]="rowGroups.length <= 1">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>

  <div class="row-actions">
    <button mat-stroked-button type="button" (click)="addRow()">Add Account Row</button>
  </div>

  @if (errorMessage) {
    <div class="error">{{errorMessage}}</div>
  }
  @if (!sortedAccounts.length) {
    <div class="empty">No accounts found. Create accounts first.</div>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="!canSubmit">Post Opening Balances</button>
</div>
